module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.bondedLoan) ? _c('div', {
    staticClass: "box loan"
  }, [_c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-header-wrapper logical-block"
  }, [_c('div', {
    staticClass: "page-header translucent-wrapper",
    style: (_vm.headerStyle)
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('b-switch', {
    model: {
      value: (_vm.loanObject.isHidden),
      callback: function($$v) {
        _vm.$set(_vm.loanObject, "isHidden", $$v)
      },
      expression: "loanObject.isHidden"
    }
  }, [_vm._v("Скрыть страницу")])], 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleLoadLoanPhoto
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Загрузить фото\n        ")])]), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок"
    },
    model: {
      value: (_vm.loanObject.title),
      callback: function($$v) {
        _vm.$set(_vm.loanObject, "title", $$v)
      },
      expression: "loanObject.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Текст",
      "type": "textarea"
    },
    model: {
      value: (_vm.loanObject.description),
      callback: function($$v) {
        _vm.$set(_vm.loanObject, "description", $$v)
      },
      expression: "loanObject.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "logical-block"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "loan-description page-header-wrapper"
  }, [_c('div', {
    staticClass: "description-wrapper"
  }, [_c('b-field', [_c('b-input', {
    staticClass: "p-option",
    attrs: {
      "placeholder": "Текст"
    },
    model: {
      value: (_vm.loanObject.aboutTitle),
      callback: function($$v) {
        _vm.$set(_vm.loanObject, "aboutTitle", $$v)
      },
      expression: "loanObject.aboutTitle"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('Editor', {
    staticClass: "p-option color-black",
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "id": 'aboutDescriptionEditor'
    },
    model: {
      value: (_vm.aboutDescription),
      callback: function($$v) {
        _vm.aboutDescription = $$v
      },
      expression: "aboutDescription"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "logical-block"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "logical-block-content"
  }, [_c('div', {
    staticClass: "description-wrapper"
  }, [_c('b-field', [_c('b-input', {
    staticClass: "p-option",
    attrs: {
      "placeholder": "Заголовок"
    },
    model: {
      value: (_vm.loanObject.advantagesTitle),
      callback: function($$v) {
        _vm.$set(_vm.loanObject, "advantagesTitle", $$v)
      },
      expression: "loanObject.advantagesTitle"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "advantages"
  }, [_vm._l((_vm.loanObject.advantages), function(advantage) {
    return _c('Advantage', {
      key: advantage.id,
      staticClass: "advantage-item",
      attrs: {
        "advantage": advantage
      }
    })
  }), _vm._v(" "), (_vm.loanObject.advantages && _vm.loanObject.advantages.length !== 2) ? _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleAddAdvantage
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить преимущество\n          ")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "logical-block"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "logical-block-content"
  }, [_c('div', {
    staticClass: "description-wrapper"
  }, [_c('b-field', [_c('b-input', {
    staticClass: "p-option",
    attrs: {
      "placeholder": "Заголовок блока"
    },
    model: {
      value: (_vm.loanObject.lettersTitle),
      callback: function($$v) {
        _vm.$set(_vm.loanObject, "lettersTitle", $$v)
      },
      expression: "loanObject.lettersTitle"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    staticClass: "p-option",
    attrs: {
      "placeholder": "Надпись на кнопке 'показать еще'"
    },
    model: {
      value: (_vm.loanObject.lettersBtnTitle),
      callback: function($$v) {
        _vm.$set(_vm.loanObject, "lettersBtnTitle", $$v)
      },
      expression: "loanObject.lettersBtnTitle"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "advantages letters"
  }, [_vm._l((_vm.loanObject.letters), function(letter) {
    return _c('Letter', {
      key: letter.id,
      staticClass: "advantage-item",
      attrs: {
        "letter": letter
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleAddLetter
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить письмо\n          ")])])], 2)])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "promo-wrapper is-flex"
  }, [_c('el-select', {
    staticClass: "p-option",
    attrs: {
      "placeholder": "Выбрать акцию",
      "clearable": ""
    },
    on: {
      "change": _vm.changePromo
    },
    model: {
      value: (_vm.selectedPromo),
      callback: function($$v) {
        _vm.selectedPromo = $$v
      },
      expression: "selectedPromo"
    }
  }, _vm._l((_vm.servicePromos), function(promo) {
    return _c('el-option', {
      key: promo.id,
      attrs: {
        "label": promo.title,
        "value": promo.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "save-content-button centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveLoan()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ') + "\n    ")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v("Описание")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v("Преимущества")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v("Письма")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v("Акция, соответствующая услуге")]), _vm._v(" "), _c('span', [_vm._v("Чтобы добавить акцию перейдите в меню \"Акции\"")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c9ac2d7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BondedLoan/Index.vue
// module id = 894
// module chunks = 0